import React from "react";
import { styled } from "styled-components";
import en from "./json/en.json";
import da from "./json/da.json";
import de from "./json/de.json";
import nl from "./json/nl.json";
import nb from "./json/nb.json";
import { Select } from "../Select";
import { Warning } from "../../icons";
import { ErrorMessage } from "../../styles/sharedInputStyles";
const CountrySelectWrapper = styled.div `
  width: 100%;
`;
const options = {
    en: Object.entries(en.countries).map(([isoCode, countryName]) => ({
        label: countryName,
        value: isoCode,
    })),
    da: Object.entries(da.countries).map(([isoCode, countryName]) => ({
        label: countryName,
        value: isoCode,
    })),
    de: Object.entries(de.countries).map(([isoCode, countryName]) => ({
        label: countryName,
        value: isoCode,
    })),
    nb: Object.entries(nb.countries).map(([isoCode, countryName]) => ({
        label: countryName,
        value: isoCode,
    })),
    nl: Object.entries(nl.countries).map(([isoCode, countryName]) => ({
        label: countryName,
        value: isoCode,
    })),
};
export const CountrySelect = ({ "data-cy": testId, errorMessage, label, locale, onChange, placeholder, required, value, disabled, state = "default", }) => {
    if (!options[locale]) {
        throw new Error(`${locale} not supported`);
    }
    const errorState = state === 'error' || errorMessage;
    return (React.createElement(CountrySelectWrapper, { "data-cy": testId },
        React.createElement(Select, { label: label, onChange: onChange, options: options[locale], optionTitleFn: (option) => option.label, optionValueFn: (option) => option.value, placeholder: placeholder, required: required, state: errorState ? "error" : "default", value: value, disabled: disabled }),
        errorMessage && (React.createElement(ErrorMessage, null,
            React.createElement(Warning, null),
            errorMessage))));
};
export default CountrySelect;
//# sourceMappingURL=CountrySelect.js.map